import { EXCHANGE_RATES_AOA, isSupportedCurrency, type SupportedCurrency } from "@/config/exchangeRates";

const LOCALE_FOR_CURRENCY: Record<SupportedCurrency, string> = {
  AOA: "pt-AO",
  USD: "en-US",
  EUR: "pt-PT",
  BRL: "pt-BR",
  ZAR: "en-ZA",
};

/**
 * Converte um valor em AOA para a moeda destino usando taxas fixas.
 */
export function convertFromAOA(amountAOA: number, currency: SupportedCurrency): number {
  const rate = EXCHANGE_RATES_AOA[currency] || 1;
  return amountAOA / rate;
}

/**
 * Formata um valor originalmente em AOA na moeda destino, sem abreviação.
 * Ex.: formatMoney(20000, "USD") → "$18.18"
 *      formatMoney(20000, "AOA") → "20.000,00 Kz"
 */
export function formatMoney(amountAOA: number, currency: string, options?: { maximumFractionDigits?: number }): string {
  const target: SupportedCurrency = isSupportedCurrency(currency) ? currency : "AOA";
  const value = convertFromAOA(Number(amountAOA || 0), target);
  const locale = LOCALE_FOR_CURRENCY[target];
  const maxDigits = options?.maximumFractionDigits ?? (target === "AOA" ? 0 : 2);

  if (target === "AOA") {
    // Manter "Kz" como sufixo com locale pt-AO (regra do projecto).
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: maxDigits,
    }).format(value) + " Kz";
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: target,
    minimumFractionDigits: 2,
    maximumFractionDigits: maxDigits,
  }).format(value);
}
